/*eslint-disable*/
import _debug from 'debug';
import { adalRequest } from './adal/adal_request';

const debug = _debug('app:post_data');
export const post = (data, ownerId) => {
  debug('Post API called');
  return adalRequest({
    ownerId: ownerId,
    method: 'post',
    apiName: 'upsert-details',
    data: data
  });
};



// WEBPACK FOOTER //
// ./src/lib/network/webapi/post_data.js